export const ROLES = {
  accountant: 'accountant',
  brotherNephewNiece: 'brother_nephew_niece',
  child: 'child',
  grandchild: 'grandchild',
  grandparent: 'grandparent',
  great_grandchild: 'great_grandchild',
  greatGrandparent: 'great_grandparent',
  hasAccountant: 'has_accountant',
  hasNotary: 'has_notary',
  maternalUncleAunt: 'maternal_uncle_aunt',
  notary: 'notary',
  other: 'other',
  parent: 'parent',
  partner: 'partner',
  paternalUncleAunt: 'paternal_uncle_aunt',
  sibling: 'sibling',
  sisterNephewNiece: 'sister_nephew_niece',
  thirdParty: 'third_party',
  legalRepresentative: 'legal_representative',
} as const

export type Role = ValueOf<typeof ROLES>

export const RELATION_ROLES = { ...ROLES, owner: 'owner' }

export const ROLE_POSITIONS = {
  [ROLES.partner]: 0,
  [ROLES.child]: 1,
  [ROLES.grandchild]: 2,
  [ROLES.great_grandchild]: 3,
  [ROLES.parent]: -2,
  [ROLES.grandparent]: -3,
  [ROLES.greatGrandparent]: -4,
  [ROLES.sibling]: -1,
  [ROLES.paternalUncleAunt]: -2,
  [ROLES.maternalUncleAunt]: -2,
  [ROLES.other]: -1,
  [ROLES.notary]: -1,
  [ROLES.hasNotary]: -1,
  [ROLES.accountant]: -1,
  [ROLES.hasAccountant]: -1,
  [ROLES.thirdParty]: -1,
  [ROLES.legalRepresentative]: -1,
  [ROLES.sisterNephewNiece]: 1,
  [ROLES.brotherNephewNiece]: 1,
} as const

export const ROLES_TO_INVERSE = {
  [ROLES.parent]: [ROLES.child],
  [ROLES.grandchild]: [ROLES.grandparent],
  [ROLES.great_grandchild]: [ROLES.greatGrandparent],
  [ROLES.sisterNephewNiece]: [ROLES.maternalUncleAunt],
  [ROLES.brotherNephewNiece]: [ROLES.paternalUncleAunt],
}

export const CREATION_TYPES = {
  partner: 'partner',
  child: 'child',
  parent: 'parent',
  sibling: 'sibling',
  brotherNephewNiece: 'brother_nephew_niece',
  sisterNephewNiece: 'sister_nephew_niece',
  paternalUncleAunt: 'paternal_uncle_aunt',
  maternalUncleAunt: 'maternal_uncle_aunt',
  grandchild: 'grandchild',
  grandparent: 'grandparent',
  greatGrandchild: 'great_grandchild',
  greatGrandparent: 'great_grandparent',
  currentUser: 'full',
  minor: 'minor',
  other: 'other',
} as const

export type CreationTypes = ValueOf<typeof CREATION_TYPES>

export const ROLES_EXCEPTIONS_BY_CREATION_TYPE = {
  [CREATION_TYPES.currentUser]: RELATION_ROLES.other,
  [CREATION_TYPES.minor]: RELATION_ROLES.other,
} as Record<string, string>

export const PROFESSIONAL_ROLES = {
  notary: true,
  has_notary: 0,
  accountant: true,
  has_accountant: 0,
  third_party: true,
}

export const PROFESSIONAL_ROLES_CSP = {
  notary: 'notary',
  accountant: 'accountant',
  third_party: 'non_executive_employee',
}
